module.exports = __webpack_public_path__ + "img/education.0ce83993.webp";